import Page from 'flarum/components/Page';
import LoadingIndicator from "flarum/components/LoadingIndicator";
import IndexPage from 'flarum/forum/components/IndexPage';

import MapModule from './components/MapModule';
import CategoryModule from './components/CategoryModule';
import LogoComponent from "./components/LogoComponent";
import UserComponent from "./components/UserComponent";
import UserSubmitComponent from "./components/UserSubmitComponent";
import SiteInfoComponent from "./components/SiteInfoComponent";

import SidebarComponent from "./components/SidebarComponent";
import MapSearchComponent from "./components/MapSearchComponent";
import StatisticBasicComponent from "./components/StatisticBasicComponent";
import AccountNeedActivateModal from "./components/modal/AccountNeedActivateModal";
import AccountBannedModal from "./components/modal/AccountBannedModal";
import AccountExpiredModal from "./components/modal/AccountExpiredModal";

import getUserInfo from "./common/util/getUserInfo";

export default class CustomIndexPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.u2diInfoList = [];
    this.u2diInfoStatistic = [];
    this.mapModule = null;

    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    if(u2diUserType9===true){
      this.selectedCategory = window.selectedCategory = "tj";
    }else{
      this.selectedCategory = window.selectedCategory = "gg";
    }

    const _this = this;

    if(app.current.data.routeName==='u2di'){
      $(".App").css("padding-top","0px");
      $("header#header").css("display","none");
      $(".affix .App-navigation").css("display","none");
    }else{
      $(".App").css("padding-top","var(--header-height)");
      $("header#header").css("display","block");
      $(".affix .App-navigation").css("display","block");
    }

    let swiperApi = document.createElement('script');
    swiperApi.charset = 'utf-8';
    swiperApi.src = './assets/extensions/ziiven-u2di/swiper/swiper-bundle.min.js';
    document.head.appendChild(swiperApi);

    swiperApi.onload = function(){
      console.log("swiperApi Loaded");
    }

    let pdflibApi = document.createElement('script');
    pdflibApi.src = './assets/extensions/ziiven-u2di/pdflib/pdf-lib.js';
    document.head.appendChild(pdflibApi);

    pdflibApi.onload = function(){
      console.log("pdflibApi Loaded");
    }

    let watermarkApi = document.createElement('script');
    watermarkApi.src = './assets/extensions/ziiven-u2di/watermarkjs/watermark.js';
    document.head.appendChild(watermarkApi);

    watermarkApi.onload = function(){
      console.log("watermarkApi Loaded");
    }

    let jspdfApi = document.createElement('script');
    jspdfApi.src = './assets/extensions/ziiven-u2di/jspdf/jspdf.umd.min.js';
    document.head.appendChild(jspdfApi);

    jspdfApi.onload = function(){
      console.log("jspdfApi Loaded");
    }

    let html2canvasApi = document.createElement('script');
    html2canvasApi.src = './assets/extensions/ziiven-u2di/html2canvas/html2canvas.min.js';
    document.head.appendChild(html2canvasApi);

    html2canvasApi.onload = function(){
      console.log("html2canvasApi Loaded");
    }

    let cryptojsApi = document.createElement('script');
    cryptojsApi.src = './assets/extensions/ziiven-u2di/cryptojs/cryptojs-aes.min.js';
    document.head.appendChild(cryptojsApi);

    let cryptojsFormatApi = document.createElement('script');
    cryptojsFormatApi.src = './assets/extensions/ziiven-u2di/cryptojs/cryptojs-aes-format.js';
    document.head.appendChild(cryptojsFormatApi);

    window.selectedTargetID = null;
    window.previewImageList = [];
    window.previewImagePointer = 0;

    $(window).on('resize', function(){
      $(".indexPageMapContainer").height($(window).height());
      window.scrollTo(0, 0);
    });

    $(window).off("u2diIndexPageSetManageCategory").on("u2diIndexPageSetManageCategory",function(e,categoryName){
      _this.selectedCategory = window.selectedCategory = categoryName;
      _this.mapModule.emit('clearInfoWindow');
      m.redraw();
    })

    $(window).off("searchPlace").on("searchPlace", function(e,searchPlace){
      const placeName = searchPlace.placeName;
      const callback = searchPlace.callback;

      _this.mapModule.plugin('AMap.PlaceSearch', function(){
        const placeSearch = new AMap.PlaceSearch({city: '全国'});
        placeSearch.search(placeName, function(status, result) {
          callback(result);
        })
      })
    });

    $(window).off("refreshNotification").on("refreshNotification", function(e){
      if(app.session.user){
        app.store
          .find("u2diNotification")
          .catch(() => {})
          .then((notificationResult) => {
        });
      }
    });

    $(window).off("u2diLocateInfoOnMap").on("u2diLocateInfoOnMap",function(e,data){
      _this.mapModule.emit('mapItemSelect',data);
    })

    $(window).trigger('refreshNotification');

    app.store
      .find("u2diUserInfo")
      .catch(() => {})
      .then((userInfo) => {
        
      m.request({
        method: "GET",
        url: "/assets/extensions/ziiven-u2di/data.json?v="+Math.floor(Math.random() * 1000),
      })
      .then((result) => {
          this.loading = false;
          this.u2diInfoStatistic = result.statistic;

          let u2diInfoList = result.data;
          [].push.apply(this.u2diInfoList, u2diInfoList);
          m.redraw();

          let userStatus = app.session.user?(getUserInfo(app.session.user.id())).userStatus():0;
          let emailConfirmed = app.session.user?(getUserInfo(app.session.user.id())).emailConfirmed():1;

          if(emailConfirmed===0){
            app.modal.show(AccountNeedActivateModal);
          }else{
            if(userStatus===1){
              app.modal.show(AccountExpiredModal);
            }else if(userStatus===2){
              app.modal.show(AccountBannedModal);
            }
          }
      })
    });
  }

  onModulesReady(){
    $(".u2diMapSearchArea").css("left","calc(50% - "+$(".u2diMapSearchArea").width()/2+"px)")
  }

  view() {
    let loading;

    if (this.loading) {
      loading = LoadingIndicator.component({ size: "large" });
    }

    const _this = this;
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const mapModuleID = "indexPageMap";
    const mapModule = this.mapModule;
    const mapInfoDataList = this.u2diInfoList;
    const infoStatistic = this.u2diInfoStatistic;
    const selectedCategory = this.selectedCategory;

    if(this.loading===false){
      let emailConfirmed = app.session.user?(getUserInfo(app.session.user.id())).emailConfirmed():1;
      let userStatus = app.session.user?(getUserInfo(app.session.user.id())).userStatus():0;

      if(userStatus===0 || userStatus===1){
        return (
          <div className="IndexPage" style={(userStatus===1 || emailConfirmed===0)?"opacity:0.5":""}>
            {loading && <div className="U2Di-loadMore">{loading}</div>}

            {!loading && (
              <div>
                {mapModule!==null && (
                  <div oncreate={this.onModulesReady.bind(this)}>
                    <div id="u2diUploadPreviewModal" className="u2diUploadPreviewModal">
                      <span className="u2diUploadPreviewModal-close" onclick={(e) => { this.closePreviewModal(); }}>&times;</span> 
                      <div className="u2diUploadPreviewModal-left" onclick={(e) => { this.previousPreviewImage(); }}><i class="fas fa-chevron-left"></i></div>
                      <div className="u2diUploadPreviewModal-right" onclick={(e) => { this.nextPreviewImage(); }}><i class="fas fa-chevron-right"></i></div>
                      <div className="u2diUploadPreviewModal-container">
                        <img class="u2diUploadPreviewModal-content" id="u2diUploadPreviewModal-content" />
                      </div>
                      <div className="u2diUploadPreviewModal-caption" id="u2diUploadPreviewModal-caption"></div>
                    </div>

                    <CategoryModule selectedCategory={selectedCategory} />

                    <div className="u2diLogoArea">
                      {LogoComponent.component()}
                    </div>

                    <div className="u2diMapMobileUserArea">
                      {UserComponent.component()}
                    </div>

                    <div className="u2diMapSearchArea">
                      <div className="u2diMapStatisticArea">
                        {StatisticBasicComponent.component({infoStatistic})}
                      </div>

                      {MapSearchComponent.component({mapModule,mapInfoDataList,infoStatistic})}
                      <div className="u2diMapSubmitArea">
                        {UserSubmitComponent.component()}
                      </div>
                    </div>

                    {SidebarComponent.component({selectedCategory,mapModule,mapModuleID,mapInfoDataList})}

                    <div className="u2diMapSiteInfoArea">
                      {SiteInfoComponent.component()}
                    </div>
                  </div>
                )}

                <MapModule 
                  mapClassName = {mapModuleID+"Container"} 
                  mapModuleID = {mapModuleID}
                  mapInfoDataList = {mapInfoDataList} 
                  mapModuleCallback = {(mapModule) => {
                      _this.mapModule = mapModule;
                      m.redraw();
                    }
                  } 
                />
              </div>
            )}
          </div>
        );
      }else if(userStatus===2){
        <div className="IndexPage"></div>
      }
    }
  }

  closePreviewModal(){
    $("#u2diUploadPreviewModal").hide();
    window.previewImageList = [];
    window.previewImagePointer = 0;
  }

  previousPreviewImage(){
    let previewImagePointer = window.previewImagePointer;
    let previewImageList = window.previewImageList;
    let prevImage = previewImageList[previewImagePointer-1];

    if(prevImage){
      $("#u2diUploadPreviewModal-content").attr("src", prevImage.path);
      $("#u2diUploadPreviewModal-caption").text(prevImage.name);
      previewImagePointer--;
      window.previewImagePointer--;

      $(".u2diUploadPreviewModal-right").show();

      if(previewImageList[previewImagePointer-1]===undefined){
        $(".u2diUploadPreviewModal-left").hide();
      }
    }
  }

  nextPreviewImage(){
    let previewImagePointer = window.previewImagePointer;
    let previewImageList = window.previewImageList;
    let nextImage = previewImageList[previewImagePointer+1];

    if(nextImage){
      $("#u2diUploadPreviewModal-content").attr("src", nextImage.path);
      $("#u2diUploadPreviewModal-caption").text(nextImage.name);
      previewImagePointer++;
      window.previewImagePointer++;

      $(".u2diUploadPreviewModal-left").show();

      if(previewImageList[previewImagePointer+1]===undefined){
        $(".u2diUploadPreviewModal-right").hide();
      }
    }
  }
}
